/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DomainLearningOutcomeTemplate,
    DomainLearningOutcomeTemplateFromJSON,
    DomainLearningOutcomeTemplateFromJSONTyped,
    DomainLearningOutcomeTemplateToJSON,
} from './DomainLearningOutcomeTemplate';
import {
    Faculty,
    FacultyFromJSON,
    FacultyFromJSONTyped,
    FacultyToJSON,
} from './Faculty';
import {
    Indicator,
    IndicatorFromJSON,
    IndicatorFromJSONTyped,
    IndicatorToJSON,
} from './Indicator';
import {
    ScienceBranch,
    ScienceBranchFromJSON,
    ScienceBranchFromJSONTyped,
    ScienceBranchToJSON,
} from './ScienceBranch';
import {
    SimpleStudyCycleEnum,
    SimpleStudyCycleEnumFromJSON,
    SimpleStudyCycleEnumFromJSONTyped,
    SimpleStudyCycleEnumToJSON,
} from './SimpleStudyCycleEnum';
import {
    StudyProgram,
    StudyProgramFromJSON,
    StudyProgramFromJSONTyped,
    StudyProgramToJSON,
} from './StudyProgram';

/**
 * 
 * @export
 * @interface Domain
 */
export interface Domain {
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Domain
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    name?: string | null;
    /**
     * 
     * @type {SimpleStudyCycleEnum}
     * @memberof Domain
     */
    studyCycle?: SimpleStudyCycleEnum;
    /**
     * 
     * @type {Array<Faculty>}
     * @memberof Domain
     */
    faculties?: Array<Faculty> | null;
    /**
     * 
     * @type {Array<StudyProgram>}
     * @memberof Domain
     */
    studyPrograms?: Array<StudyProgram> | null;
    /**
     * 
     * @type {Array<Indicator>}
     * @memberof Domain
     */
    indicators?: Array<Indicator> | null;
    /**
     * 
     * @type {Array<DomainLearningOutcomeTemplate>}
     * @memberof Domain
     */
    learningOutcomeTemplates?: Array<DomainLearningOutcomeTemplate> | null;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    abbreviation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Domain
     */
    scienceBranchId?: string;
    /**
     * 
     * @type {ScienceBranch}
     * @memberof Domain
     */
    scienceBranch?: ScienceBranch;
}

export function DomainFromJSON(json: any): Domain {
    return DomainFromJSONTyped(json, false);
}

export function DomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): Domain {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'studyCycle': !exists(json, 'studyCycle') ? undefined : SimpleStudyCycleEnumFromJSON(json['studyCycle']),
        'faculties': !exists(json, 'faculties') ? undefined : (json['faculties'] === null ? null : (json['faculties'] as Array<any>).map(FacultyFromJSON)),
        'studyPrograms': !exists(json, 'studyPrograms') ? undefined : (json['studyPrograms'] === null ? null : (json['studyPrograms'] as Array<any>).map(StudyProgramFromJSON)),
        'indicators': !exists(json, 'indicators') ? undefined : (json['indicators'] === null ? null : (json['indicators'] as Array<any>).map(IndicatorFromJSON)),
        'learningOutcomeTemplates': !exists(json, 'learningOutcomeTemplates') ? undefined : (json['learningOutcomeTemplates'] === null ? null : (json['learningOutcomeTemplates'] as Array<any>).map(DomainLearningOutcomeTemplateFromJSON)),
        'abbreviation': !exists(json, 'abbreviation') ? undefined : json['abbreviation'],
        'scienceBranchId': !exists(json, 'scienceBranchId') ? undefined : json['scienceBranchId'],
        'scienceBranch': !exists(json, 'scienceBranch') ? undefined : ScienceBranchFromJSON(json['scienceBranch']),
    };
}

export function DomainToJSON(value?: Domain | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'studyCycle': SimpleStudyCycleEnumToJSON(value.studyCycle),
        'faculties': value.faculties === undefined ? undefined : (value.faculties === null ? null : (value.faculties as Array<any>).map(FacultyToJSON)),
        'studyPrograms': value.studyPrograms === undefined ? undefined : (value.studyPrograms === null ? null : (value.studyPrograms as Array<any>).map(StudyProgramToJSON)),
        'indicators': value.indicators === undefined ? undefined : (value.indicators === null ? null : (value.indicators as Array<any>).map(IndicatorToJSON)),
        'learningOutcomeTemplates': value.learningOutcomeTemplates === undefined ? undefined : (value.learningOutcomeTemplates === null ? null : (value.learningOutcomeTemplates as Array<any>).map(DomainLearningOutcomeTemplateToJSON)),
        'abbreviation': value.abbreviation,
        'scienceBranchId': value.scienceBranchId,
        'scienceBranch': ScienceBranchToJSON(value.scienceBranch),
    };
}

